import { LoadingOverlay } from "./loading-overlay";

export function AuthenticationCheck() {
    return <LoadingOverlay show={true} />;
}